module.exports = __webpack_public_path__ + "static/img/3.9a93d4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/eg/3.png
// module id = 123
// module chunks = 2